import React, { useCallback, useEffect } from 'react'
import { Button, Form, Input, Modal, Switch, DatePicker, Space } from 'antd'
import DecimalInput from '../../DecimalInput'
import { parseDate } from '../../../utils/date-format'

const { TextArea } = Input

const ApplicationPaymentFormModal = ({ showModal, payment, onFinish, onCancel, onError }) => {
  const [form] = Form.useForm()

  useEffect(
    () =>
      payment &&
      form.setFieldsValue({
        is_full: payment.is_full,
        paid: payment.paid,
        pay_date: parseDate(payment.pay_date, 'YYYY-MM-DD'),
        description: payment.description,
      }),
    [payment]
  )

  const clear = () => form.resetFields()

  const onCancelCallback = () => {
    clear()
    onCancel()
  }

  const onFinishCallback = useCallback(
    async (data) => {
      try {
        await onFinish(data)
        clear()
      } catch (err) {
        onError(err.error)
      }
    },
    [onFinish]
  )

  return (
    <Modal
      title="Платёж заявки"
      visible={showModal}
      onCancel={onCancelCallback}
      footer={[
        <Button key="back" onClick={() => form.submit()}>
          Сохранить
        </Button>,
      ]}
    >
      <Form
        name="app-payment"
        autoComplete="off"
        layout="horizontal"
        onFinish={onFinishCallback}
        initialValues={{ is_full: false }}
        form={form}
        size="large"
      >
        <Form.Item name="is_full" label="Оплачено полностью" valuePropName="checked" labelCol={{ span: 24 }}>
          <Switch />
        </Form.Item>
        <Space>
          <Form.Item name="paid" label="Оплачено" labelCol={{ span: 24 }}>
            <DecimalInput style={{ minWidth: 200 }} />
          </Form.Item>
          <Form.Item name="pay_date" label="Дата" labelCol={{ span: 24 }}>
            <DatePicker placeholder="Дата оплаты" format="DD.MM.YYYY" />
          </Form.Item>
        </Space>
        <Form.Item name="description" label="Комментарий" labelCol={{ span: 24 }}>
          <TextArea rows={4} />
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default ApplicationPaymentFormModal
